import { isMobile } from 'react-device-detect';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  drawer: {
    flexShrink: 0,
    zIndex: theme.zIndex.drawer + 2,
  },
  drawerPaper: {
    width: isMobile ? '100vw' : 'fit-content',
    border: 0,
    backgroundColor: theme.palette.grey[700],
    padding: theme.spacing(2, 0),
  },
  pageTextLinks: {
    '& li': {
      padding: theme.spacing(2, 0),
    },
    '& a': {
      color: 'inherit',
      textDecoration: 'inherit',
    },
  },
  legalLinks: {
    '& li': {
      padding: theme.spacing(1.5, 0),
      '& a': {
        color: theme.palette.grey[400],
        textDecoration: 'inherit',
      },
    },
  },
  title: {
    marginTop: theme.spacing(6),
    marginLeft: theme.spacing(4),
    width: '70%',
  },
}));

export default useStyles;
